import React from "react";

import styles from "./index.module.scss";
import { ISinglePin } from "src/shared/types";
import ChartFallback from "src/shared/components/ChartFallback";

interface IRibbonProps {
  details: ISinglePin;
  height: number;
}
const RibbonCard = (props: IRibbonProps) => {
  const cardDetails = props.details;
  const { bigNumber, vCompare, progress, successful, isPositive } = cardDetails;
  return (
    <div className={styles["container"]} style={{ height: props.height }}>
      <div className={styles["content"]}>
        <div className={styles["ribbon-head"]}>{cardDetails.label}</div>
        {successful === false ? (
          <ChartFallback />
        ) : (
          <>
            <div className={styles["big-number"]}> {bigNumber}</div>
            <div
              className={
                vCompare === ""
                  ? styles["chart-progress-neutral"]
                  : `${progress == isPositive ? styles["chart-progress-up"] : styles["chart-progress-down"]} ${
                      progress ? styles["up-arrow"] : styles["down-arrow"]
                    }`
              }
            >
              {vCompare}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RibbonCard;
